module.exports = __webpack_public_path__ + "img/list-2.ba25c0.svg";